import styled from 'styled-components';
import { Notification } from '../Notification';
export var BannerRoot = styled(Notification.Root).withConfig({
  displayName: "components__BannerRoot",
  componentId: "sc-12jf7gp-0"
})(function (_ref) {
  var theme = _ref.theme;
  return "\n    border: 0px;\n    padding: " + theme.space[3] + "px " + theme.space[4] + "px;\n    width: 100%;\n  ";
});